import React from 'react';

const Help = () => {
    return (
        <div className="aboutpage" >
            <h2 className="about-line" >Help</h2>
            <div>
                <ul>
                    <li>ABHINAV GUPTA</li>
                    <li>B.Tech / Institute of Engineering & Technology, Lucknow</li>
                    <li>Email = abhinav.gupta.1220@gmail.com</li>
                    <li>LinkeIn = https://www.linkedin.com/in/abhinav1220/</li>
                    <li>GitHub = https://github.com/a-bit-git</li>
                </ul>
            </div>
        </div>
    );
};

export default Help;